module.exports = __webpack_public_path__ + "static/media/1008384.c349121d.png";